import {Navigate} from 'react-router';

export const stationDetailRoutes = [
  {
    path: '',
    lazy: () =>
      import('../../../../screens/stations/StationDetail/StationDashboard'),
  },
  {
    path: 'forecast',
    lazy: () =>
      import('../../../../screens/stations/StationDetail/StationForecast'),
  },
  {
    path: 'forecast-comparison',
    lazy: () =>
      import('../../../../screens/stations/StationDetail/StationForecastComparison'),
  },
  {
    path: 'history',
    lazy: () =>
      import('../../../../screens/stations/StationDetail/StationHistory'),
  },
  {
    path: 'analysis',
    lazy: () =>
      import('../../../../screens/stations/StationDetail/StationAnalysis'),
  },
  {
    path: 'analysis/records',
    lazy: () =>
      import('../../../../screens/stations/StationDetail/StationAnalysis/RecordsReport'),
  },
  {
    path: 'analysis/monthly-outdoor',
    lazy: () =>
      import('../../../../screens/stations/StationDetail/StationAnalysis/MonthlyOutdoorReport'),
  },
  {
    path: 'analysis/annual-outdoor',
    lazy: () =>
      import('../../../../screens/stations/StationDetail/StationAnalysis/AnnualOutdoorReport'),
  },
  {
    path: 'analysis/annual-comparison',
    lazy: () =>
      import('../../../../screens/stations/StationDetail/StationAnalysis/AnnualComparisonReport'),
  },
  {
    path: 'analysis/temperature-feel',
    lazy: () =>
      import('../../../../screens/stations/StationDetail/StationAnalysis/TemperatureFeelReport'),
  },
  {
    path: 'analysis/dew-point',
    lazy: () =>
      import('../../../../screens/stations/StationDetail/StationAnalysis/DewPointReport'),
  },
  {
    path: 'analysis/temperature-comparison',
    lazy: () =>
      import('../../../../screens/stations/StationDetail/StationAnalysis/TemperatureComparisonReport'),
  },
  {
    path: 'analysis/wind-monthly',
    lazy: () =>
      import('../../../../screens/stations/StationDetail/StationAnalysis/MonthlyWindReport'),
  },
  {
    path: 'analysis/wind-run',
    lazy: () =>
      import('../../../../screens/stations/StationDetail/StationAnalysis/WindRunReport'),
  },
  {
    path: 'analysis/rain-annual',
    lazy: () =>
      import('../../../../screens/stations/StationDetail/StationAnalysis/AnnualRainReport'),
  },
  {
    path: 'analysis/rain-comparison',
    lazy: () =>
      import('../../../../screens/stations/StationDetail/StationAnalysis/RainComparisonReport'),
  },
  {
    path: 'analysis/grassland-temperature',
    lazy: () =>
      import('../../../../screens/stations/StationDetail/StationAnalysis/GrasslandTemperatureReport'),
  },
  {
    path: 'analysis/annual-water-balance',
    lazy: () =>
      import('../../../../screens/stations/StationDetail/StationAnalysis/AnnualWaterBalanceReport'),
  },
  {
    path: 'sensors/:sensorType',
    lazy: () =>
      import('../../../../screens/stations/StationDetail/SensorCharts'),
  },
  {
    path: 'sensors/:sensorType/:chartType',
    lazy: () =>
      import('../../../../screens/stations/StationDetail/SensorCharts/SensorChart'),
  },
  {
    path: '*',
    element: <Navigate to={''} replace />,
  },
];
